import { useGlobalState } from "@hooks/useGlobalState";

/**
 * Returns the current scene tree version. This value increments whenever
 * SceneManager's tree changes (populateSceneFromModelsAndNodes, setTreeRows,
 * rebuildTree, clear). Use in dependency arrays so useMemo/useEffect recompute
 * when the scene/tree updates (appStore.sceneManager.treeVersion is not
 * observable, so this global state is the reactive trigger).
 */
export function useSceneTreeVersion(): number {
  const [sceneTreeVersion] = useGlobalState("sceneTreeVersion");
  return sceneTreeVersion;
}
